/** Display helpers — keep the contract data canonical, format only at the edge. */

/** ISO instant → 12-hour clock in a timezone, e.g. { h: "7:50", ampm: "AM" }. */
export function instantTo12h(iso: string, tz: string): { h: string; ampm: string } {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(new Date(iso));
  const h = parts.find((p) => p.type === "hour")?.value ?? "";
  const m = parts.find((p) => p.type === "minute")?.value ?? "";
  const ampm = (parts.find((p) => p.type === "dayPeriod")?.value ?? "").toUpperCase();
  return { h: `${h}:${m}`, ampm };
}

/** Minutes → "1h 30m" / "90m" for routine sliders. */
export function minutesLabel(min: number): string {
  if (min < 60) return `${min}m`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

/** "HH:MM" 24h (canonical) → 12h clock label, e.g. "09:20" → "9:20 AM". */
export function hhmmTo12h(hhmm: string): string {
  const [h, m] = hhmm.split(":").map(Number);
  if (h === undefined || m === undefined) return hhmm;
  const ampm = h < 12 ? "AM" : "PM";
  const hh = h % 12 || 12;
  return `${hh}:${m.toString().padStart(2, "0")} ${ampm}`;
}
